import { render } from "./accountBook.vue?vue&type=template&id=d3253684"
import script from "./accountBook.vue?vue&type=script&lang=js"
export * from "./accountBook.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__